function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PAGINATION_CLASS = {
  PREVIOUS_BUTTON: 'js-previous',
  NEXT_BUTTON: 'js-next',
  SELECTOR: 'js-selector',
  DISABLED: 'km-pagination__button--disabled'
};
export var Pagination = /*#__PURE__*/function () {
  /**
   *
   * @param {HTML Element} prmClass need to be an actuel pagination DOM element
   * @param {Function} prmFunction need to be an arrow function to be executed when pagination has changed
   */
  function Pagination(prmClass) {
    var prmFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return null;
    };
    _classCallCheck(this, Pagination);
    //Selector
    this.paginationLayout = document.querySelector(".".concat(prmClass));
    //Attributes
    this.currentPage = parseInt(this.paginationLayout.dataset.current, 10);
    this.maxPage = parseInt(this.paginationLayout.dataset.maxPage, 10);
    this.minPage = 1;
    this.limit = parseInt(this.paginationLayout.dataset.limit, 10);
    this.url = this.paginationLayout.dataset.url;
    //Elements
    this.previousButton = this.paginationLayout.querySelector(".".concat(PAGINATION_CLASS.PREVIOUS_BUTTON));
    this.nextButton = this.paginationLayout.querySelector(".".concat(PAGINATION_CLASS.NEXT_BUTTON));
    this.selector = this.paginationLayout.querySelector(".".concat(PAGINATION_CLASS.SELECTOR));
    this.hasChanged = prmFunction;
    if (this.selector !== undefined && this.selector !== null) {
      this.initializeSelector();
    }
    this.initializeButton();
  }
  return _createClass(Pagination, [{
    key: "initializeButton",
    value: function initializeButton() {
      var _this = this;
      this.nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this.updatePagination('next');
      });
      this.previousButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this.updatePagination('previous');
      });
    }
  }, {
    key: "appendButton",
    value: function appendButton() {
      this.previousButton.classList.remove(PAGINATION_CLASS.DISABLED);
      this.nextButton.classList.remove(PAGINATION_CLASS.DISABLED);
      switch (this.currentPage) {
        case 1:
          this.previousButton.classList.add(PAGINATION_CLASS.DISABLED);
          break;
        case this.maxPage:
          this.nextButton.classList.add(PAGINATION_CLASS.DISABLED);
          break;
        default:
          break;
      }
    }
  }, {
    key: "initializeSelector",
    value: function initializeSelector() {
      var _this2 = this;
      this.selector.addEventListener('change', function () {
        _this2.updatePagination();
      });
    }
  }, {
    key: "updateSelectorValue",
    value: function updateSelectorValue() {
      if (this.selector !== undefined && this.selector !== null) {
        this.selector.value = this.currentPage;
      }
    }

    /**
     *
     * @param {String} prmMode can be previous, next or empty
     */
  }, {
    key: "updatePagination",
    value: function updatePagination() {
      var prmMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      switch (prmMode) {
        case 'next':
          if (this.currentPage < this.maxPage) {
            this.currentPage++;
            this.updateSelectorValue();
          }
          break;
        case 'previous':
          if (this.currentPage > this.minPage) {
            this.currentPage--;
            this.updateSelectorValue();
          }
          break;
        default:
          this.currentPage = parseInt(this.selector.options[this.selector.selectedIndex].value, 10);
          break;
      }
      this.appendButton();
      this.hasChanged();
      this.paginationLayout.dataset.current = this.currentPage;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var params = {
        page: this.currentPage,
        limit: this.limit
      };
      return "".concat(this.url, "?").concat(_serialize(params));
    }
  }, {
    key: "getParam",
    value: function getParam() {
      var params = {
        page: this.currentPage,
        limit: this.limit
      };
      return "".concat(_serialize(params));
    }
  }]);
}();

/**
 *
 * @param {Object} prmObj need to be a JSON object you want to serialize
 */
function _serialize(prmObj) {
  var str = [];
  for (var p in prmObj) if (Object.prototype.hasOwnProperty.call(prmObj, p)) {
    str.push("".concat(encodeURIComponent(p), "=").concat(encodeURIComponent(prmObj[p])));
  }
  return str.join('&');
}